function calculator () {
    const calculator = document.querySelector('.calculator__inner');

    if(calculator) {
        // Получаем элементы
        const numberInput = document.getElementById('numberInput');
        const rangeInput = document.getElementById('rangeInput');
        const resultValue = document.getElementById('resultValue');
        const productSelect = document.getElementById('productSelect');

        let totalMain = 0;
        let totalOptionally = 0;

        // Функция для вычисления результата основного продукта
        function calculateResult() {
            const selectedOption = productSelect.options[productSelect.selectedIndex];
            const price = selectedOption.getAttribute('data-price');
            const quantity = numberInput.value;
            const quantityValue = quantity === '' ? 0 : parseFloat(quantity);

            totalMain = price * quantityValue; // Обновляем totalMain
            resultValue.textContent = totalMain; // Обновляем на странице
            updateFinalTotal(); // Обновляем финальную сумму
        }

        // Функция для подсчета суммы всех dynamic-input
        function calculateTotalOptionally() {
            const dynamicInputs = document.querySelectorAll('.calculator__form .dynamic-input');
            totalOptionally = 0; // Сбрасываем сумму
            dynamicInputs.forEach(input => {
                totalOptionally += parseFloat(input.value) || 0;
            });
            updateFinalTotal(); // Обновляем финальную сумму
        }

        // Функция для обновления финальной суммы
        function updateFinalTotal() {
            const finalTotal = totalMain + totalOptionally;
            resultValue.textContent = finalTotal;
        }

        // События для пересчета основной части
        window.addEventListener('load', calculateResult);
        productSelect.addEventListener('change', calculateResult);
        numberInput.addEventListener('input', calculateResult);
        rangeInput.addEventListener('input', () => {
            numberInput.value = rangeInput.value;
            calculateResult();
        });

        // Обновляем калькуляцию опций при взаимодействии
        const accordionItems = document.querySelectorAll('.calculator__accordion');

        accordionItems.forEach(item => {
            const btns = item.querySelectorAll('.calculator__options-btn');
            const minusBtn = item.querySelector('.calculator__options-btn.minus');
            const plusBtn = item.querySelector('.calculator__options-btn.plus');
            const input = item.querySelector('.calculator__options-input');
            const inputName = input.dataset.name;

            function calcPrice() {
                const dynamicInput = document.querySelector(`[name="${inputName}"]`);
                if (dynamicInput) {
                    dynamicInput.value = input.value * input.dataset.price;
                    calculateTotalOptionally(); // Пересчитываем сумму опций
                }
            }

            plusBtn.addEventListener('click', () => {
                input.value = parseInt(input.value) + 1;
                calcPrice();
            });

            minusBtn.addEventListener('click', () => {
                if (input.value > 0) {
                    input.value = parseInt(input.value) - 1;
                    calcPrice();
                }
            });

            btns.forEach(btn => {
                btn.addEventListener('click', calcPrice);
            });

            input.addEventListener('input', calcPrice);

            input.addEventListener('blur', () => {
                if (input.value === "") {
                    input.value = 0;
                    calcPrice();
                }
            });
        });

        // Настройка отображения доп функций при клике на переключатель
        const optionallySwitcher = document.querySelectorAll('.calculator__switcher');
        const form = document.querySelector('.calculator__form'); // Получаем форму

        optionallySwitcher.forEach(el => {
            el.addEventListener('click', function () {
                const parent = this.closest('.calculator__accordion');
                const input = parent.querySelector('.calculator__options-input');
                const inputName = input.dataset.name;

                parent.classList.toggle('active');

                if (parent.classList.contains('active')) {
                    const newInput = document.createElement('input');
                    newInput.name = inputName;
                    newInput.type = 'hidden';
                    newInput.value = input.value * input.dataset.price;
                    newInput.classList.add('dynamic-input');
                    form.appendChild(newInput);
                    calculateTotalOptionally(); // Пересчитываем сумму опций
                } else {
                    const existingInput = form.querySelector(`input[name="${inputName}"]`);
                    input.value = 0;
                    if (existingInput) {
                        existingInput.remove();
                        calculateTotalOptionally(); // Пересчитываем сумму опций
                    }
                }
            });
        });

    }
}

export default calculator;